'use client';
import { FC, useMemo } from 'react';
import { CatButton } from 'components/blocks-components';
import { Conditional, MyEquipmentButton } from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { selectEquipment } from 'services/equipment/actions';
import Styles from './my-equipment-card.module.scss';

interface SerialNumberProps {
  serialNumber: string;
  equipmentId: string;
  handleOpen: VoidFunction;
}

const SerialNumber: FC<SerialNumberProps> = ({
  serialNumber,
  equipmentId,
  handleOpen
}) => {
  const t = useTranslations();

  const serialNumberComp = useMemo(() => {
    return (
      <div className="px-3">
        <form action={selectEquipment.bind(null, equipmentId, serialNumber)}>
          <CatButton size="sm" type="submit">
            {t('VIEW_PARTS_DIAGRAM')}
          </CatButton>
        </form>
      </div>
    );
  }, [equipmentId, serialNumber, t]);

  return (
    <div className="pt-1 pb-2">
      <Conditional test={!serialNumber} fallback={serialNumberComp}>
        <MyEquipmentButton
          variant="ghost"
          className={`${Styles['c-equipment-card__btn']} px-3`}
          onClick={handleOpen}
        >
          <span className={`${Styles['c-equipment-card__btn--text']}`}>
            {t('ADD_SN_VIEW_PARTS_DIAGRAM')}
          </span>
        </MyEquipmentButton>
      </Conditional>
    </div>
  );
};

export default SerialNumber;
